if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  const moutLockTimers = {};

  function moutSetVariantPickerLocked(sectionId, locked) {
    const variantSelects = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
    if (variantSelects) {
      variantSelects.classList.toggle('mout-variant-picker--locked', locked);
    }
  }

  // Lock the variant picker the instant a new option is picked so a second,
  // overlapping click can't fire before the first variant swap (price,
  // badge, url) has actually resolved — that overlap is what caused the
  // badge/button state to briefly go out of sync when switching quickly.
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (payload) => {
    const sectionId = payload?.data?.event?.currentTarget?.dataset?.section;
    if (!sectionId) return;

    moutSetVariantPickerLocked(sectionId, true);
    clearTimeout(moutLockTimers[sectionId]);
    moutLockTimers[sectionId] = setTimeout(() => moutSetVariantPickerLocked(sectionId, false), 4000);
  });

  subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
    const sectionId = payload?.data?.sectionId;
    const variant = payload?.data?.variant;
    if (!sectionId) return;

    clearTimeout(moutLockTimers[sectionId]);
    moutSetVariantPickerLocked(sectionId, false);

    const badge = document.querySelector(`[data-mout-pickup-only-badge][data-section="${sectionId}"]`);
    if (!badge || badge.dataset.moutPickupAlways === 'true') return;

    const isRefill = !!(variant && variant.title && variant.title.indexOf('Refill') !== -1);
    badge.classList.toggle('badge--pickup-only--off', !isRefill);
  });
}
